import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import MeesterlijkeSnitInMiddelharnis from "./sections/MeesterlijkeSnitInMiddelharnis";
import OurSpecialties from "./sections/OurSpecialties";
import WaaromKiezenVoorHE from "./sections/WaaromKiezenVoorHE";
import DeHeErvaringInBeeld from "./sections/DeHeErvaringInBeeld";
import CustomerReviews from "./sections/CustomerReviews";
import KlaarVoorEenNieuweLook from "./sections/KlaarVoorEenNieuweLook";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <MeesterlijkeSnitInMiddelharnis />
      <OurSpecialties />
      <WaaromKiezenVoorHE />
      <DeHeErvaringInBeeld />
      <CustomerReviews />
      <KlaarVoorEenNieuweLook />
      <Footer />
    </div>;
}